import React, { useEffect, useState } from 'react'
import HttpClient from '../../utils/HttpClient';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import toast from 'react-hot-toast';
import { Oval } from 'react-loader-spinner';
import nophoto from '../../Images/nophoto.jpg'

const NonMemberEdit = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const data = location?.state
    const initdata = {
        personName: data?.personName,
        designationID: data?.designationID,
        mobileNo: data?.mobileNo,
        companyName: data?.companyName,
        companyTypeID: data?.companyTypeID,
        companyTypeName: "",
        emailId: data?.emailId,
        password: data?.passwordView,
        emirate: data?.emirate,
        country: data?.country,
        countryName: data?.countryName,
        countryCodeMobile: data?.phone_code,
        whatsappNo: data?.whatsappNo,
        countryCodewhatsappNo: data?.whats_code,
        telephoneNo: data?.telephoneNo,

        websiteLink: data?.websiteLink,
        address: data?.address,
        locationLink: data?.locationLink,
        facebookLink: data?.facebookLink,
        instaLink: data?.instaLink,
        twitterURL: data?.twitterURL,
        youtubeLink: data?.youtubeLink,
        profilePhoto:data?.profilePhoto,
        neooBusinessPageLink:data?.neooBusinessPageLink,

    };
    const [NonMemberProfileAdd, setNonMemberProfileAdd] = useState(initdata);
    const [Designation, setDesignation] = useState([]);
    const [contactdetail, setContactdetail] = useState(true);
    const [showmodal, setShowmodal] = useState(false);
    const [invitationProfile, setinvitationProfile] = useState([]);
    const [Business, setBusiness] = useState([]);
    const [Country, setCountry] = useState([]);
    const [passwordChanged, setPasswordChanged] = useState(false);
    const [CountryWiseState, setCountryState] = useState([]);

    useEffect(() => {
        getDesignation();
        getBuisinessType();
        getCountry();
    }, []);
    useEffect(() => {
        getState();
    }, [NonMemberProfileAdd.country]);
    // bcrypt passwrd
    // useEffect(() => {
    //     if (data?.token && !passwordChanged) {
    //         const decoded = jwtDecode(data.token);
    //         setNonMemberProfileAdd((prev) => ({ ...prev, password: decoded?.password }));
    //     }
    // }, [data?.token, passwordChanged]);


    //Designation
    const getDesignation = async () => {
        const res = await HttpClient.requestData("view-designation", "GET", {});

        if (res && res?.status) {
            setDesignation(res?.data);
        }
    };
    useEffect(() => {
        if (NonMemberProfileAdd?.companyTypeID) {
            const data = Business?.filter(
                (item) => item?._id === NonMemberProfileAdd?.companyTypeID
            );
            setNonMemberProfileAdd((prev) => ({
                ...prev,
                companyTypeName: data?.[0]?.type,
            }));
        }
    }, [NonMemberProfileAdd?.companyTypeID]);
    // country name
    useEffect(() => {
        const countryName = Country.filter((item) => item?._id === NonMemberProfileAdd.country)
        setNonMemberProfileAdd(prev => ({ ...prev, "countryName": countryName?.[0]?.name }));
    }, [NonMemberProfileAdd.country]);
    //typeof business
    const getBuisinessType = async () => {
        const res = await HttpClient.requestData("view-companyType", "GET", {});

        if (res && res?.status) {
            setBusiness(res?.data);
        }
    };
    //country
    const getCountry = async () => {
        const res = await HttpClient.requestData("countries", "GET", {});

        if (res && res?.status) {
            setCountry(res?.data);

        }
    };
    //state
    const getState = async () => {
        const res = await HttpClient.requestData(
            "countrywise-state/" + NonMemberProfileAdd.country,
            "GET",
            {}
        );

        if (res && res?.status) {
            setCountryState(res?.data?.[0]?.states);
        }
    };

    //handlechange
    const handleChange = (e) => {
        const { name, value } = e.target;

        setNonMemberProfileAdd((prev) => ({ ...prev, [name]: value }));
    };
    const handleNumberChange = (e) => {
        const { name, value } = e.target;
        // Ensure only positive numbers are entered
        // const newValue = Math.max(0, parseInt(value));

        setNonMemberProfileAdd((prev) => ({ ...prev, [name]: value }));
    };

    // handle sublit 
    const handleSubmit = async (e) => {
        e.preventDefault();
        const dataEdit = {
            personName: NonMemberProfileAdd?.personName,
            designationID: NonMemberProfileAdd?.designationID,
            mobileNo: NonMemberProfileAdd?.mobileNo.toString(),
            companyName: NonMemberProfileAdd?.companyName,
            companyTypeID: NonMemberProfileAdd?.companyTypeID,
            companyTypeName: NonMemberProfileAdd?.companyTypeName,
            emailId: NonMemberProfileAdd?.emailId,
            emirate: NonMemberProfileAdd?.emirate,
            country: NonMemberProfileAdd?.country,
            countryName: NonMemberProfileAdd?.countryName,
            whatsappNo: NonMemberProfileAdd?.whatsappNo?.toString(),
            password: NonMemberProfileAdd?.password,
            phone_code: NonMemberProfileAdd.countryCodeMobile,
            whats_code: NonMemberProfileAdd.countryCodewhatsappNo,
            telephoneNo: NonMemberProfileAdd.telephoneNo,

            websiteLink: NonMemberProfileAdd.websiteLink,
            address: NonMemberProfileAdd.address,
            locationLink: NonMemberProfileAdd.locationLink,
            facebookLink: NonMemberProfileAdd.facebookLink,
            instaLink: NonMemberProfileAdd.instaLink,
            twitterURL: NonMemberProfileAdd.twitterURL,
            youtubeLink: NonMemberProfileAdd.youtubeLink,
            profilePhoto: NonMemberProfileAdd.profilePhoto,

            neooBusinessPageLink: NonMemberProfileAdd.neooBusinessPageLink,
        };

        const res = await HttpClient.requestData("user/" + data?._id, "PUT", dataEdit)
        if (res && res?.status) {
            toast.success("Updated Succesfully")
            navigate("/non-member")
        }
        else {
            toast.error(res?.msg)
        }

    }

    const [isUploadingLogo, setIsUploadingLogo] = useState(false)

// select the Image
    const handleUpload = async (e) => {
        const { name, files } = e.target;
        setIsUploadingLogo(true)
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                setNonMemberProfileAdd(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
                setIsUploadingLogo(false)
            }
        }
    };


    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">


                <section className="piechartsBox_area bg-light">
                    <div className="container">
                        <div className="row justify-content-md-center">
                            <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                                <h3 className="fs-6 text-secondary mb-2 text-uppercase text-center">
                                    update non member
                                </h3>

                                <hr className="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row gy-3 gy-md-4 gy-lg-0 justify-content-md-center">

                            <div className="col-12 col-lg-12">
                                <div className="row justify-content-xl-center">
                                    <div className="col-12 col-xl-11">
                                        <div className="bg-white border rounded shadow-sm overflow-hidden">
                                            <form action="#!">
                                                <div className="row gy-4 gy-xl-5 p-4 p-xl-5">
                                                    {/* Profile Photo */}
                                                    <div className="col-3">
                                                        <label htmlFor="logo" className="form-label" style={{ display: "block" }}>
                                                            Profile Photo
                                                        </label>
                                                        {
                                                            isUploadingLogo ?
                                                                <Oval
                                                                    height={80}
                                                                    width={80}
                                                                    color="#4fa94d"
                                                                    wrapperStyle={{}}
                                                                    wrapperClass=""
                                                                    visible={true}
                                                                    ariaLabel='oval-loading'
                                                                    secondaryColor="#4fa94d"
                                                                    strokeWidth={2}
                                                                    strokeWidthSecondary={2}
                                                                /> :
                                                                <img
                                                                    src={NonMemberProfileAdd.profilePhoto || nophoto}
                                                                    style={{ maxWidth: "100%", maxHeight: "200px", padding: "5px 0" }}
                                                                />
                                                        }
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            name="profilePhoto"
                                                            // value={NonMemberProfileAdd.companyName}
                                                            onChange={(e) => handleUpload(e)}
                                                        />
                                                    </div>
                                                    {/* Name */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Full Name <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="personName"
                                                            value={NonMemberProfileAdd.personName}
                                                            placeholder="Your Full Name"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    {/* company type */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Company Type <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            className="form-control"
                                                            id="fullname"
                                                            name="companyTypeID"

                                                            value={NonMemberProfileAdd.companyTypeID}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="" >
                                                                Select Type of Business
                                                            </option>
                                                            {Business.map((item, i) => (
                                                                <option key={i} value={item?._id}>
                                                                    {item?.type}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* Company name */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Company Name <span className="text-danger">*</span>
                                                        </label>
                                                        <input

                                                            className="form-control"
                                                            type="text"
                                                            name="companyName"
                                                            value={NonMemberProfileAdd.companyName}
                                                            placeholder="Company Name"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    {/* designation */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Designation <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            className="form-control"
                                                            name="designationID"
                                                            value={NonMemberProfileAdd.designationID}

                                                            onChange={handleChange}
                                                        >
                                                            <option value="" >
                                                                Select Designation
                                                            </option>
                                                            {Designation.map((item, i) => (
                                                                <option key={i} value={item?._id}>
                                                                    {item?.designation}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* email */}
                                                    <div className="col-12 col-md-12">
                                                        <label htmlFor="email" className="form-label">
                                                            Email <span className="text-danger">*</span>
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-envelope"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                                                                </svg>
                                                            </span>
                                                            <input

                                                                className="form-control ml-1"
                                                                type="email"
                                                                name="emailId"
                                                                value={NonMemberProfileAdd.emailId}
                                                                placeholder="Email Id"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* password */}
                                                    <div className="col-12 col-md-12">
                                                        <label htmlFor="email" className="form-label">
                                                            Password <span className="text-danger">*</span>
                                                        </label>
                                                        <div className="input-group">

                                                            <input

                                                                className="form-control"
                                                                type="text"
                                                                name="password"
                                                                value={NonMemberProfileAdd.password}
                                                                placeholder="Enter new password"
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* phone number */}
                                                    <div className="col-12 col-md-12">
                                                        <label htmlFor="phone" className="form-label">
                                                            Phone Number
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-telephone"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                                                </svg>
                                                            </span>
                                                            <select
                                                                type="tel"
                                                                className="form-control col-2 mr-1 ml-1"
                                                                name="countryCodeMobile"
                                                                value={NonMemberProfileAdd.countryCodeMobile}
                                                                onChange={handleChange}

                                                            >
                                                                {Country.map((item, i) => (
                                                                    <option key={i} value={item?.phone_code}>
                                                                        {item?.emoji} {item?.phone_code}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="telephoneNo"
                                                                value={NonMemberProfileAdd.telephoneNo}
                                                                onChange={handleNumberChange}
                                                                placeholder="Mobile Number "

                                                            />
                                                        </div>
                                                    </div>
                                                    {/* mobile number */}
                                                    <div className="col-12 col-md-12">
                                                        <label htmlFor="phone" className="form-label">
                                                            Mobile Number
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-telephone"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                                                </svg>
                                                            </span>
                                                            <select
                                                                type="tel"
                                                                className="form-control col-2 mr-1 ml-1"
                                                                name="countryCodeMobile"
                                                                value={NonMemberProfileAdd.countryCodeMobile}
                                                                onChange={handleChange}

                                                            >
                                                                {Country.map((item, i) => (
                                                                    <option key={i} value={item?.phone_code}>
                                                                        {item?.emoji} {item?.phone_code}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="mobileNo"
                                                                value={NonMemberProfileAdd.mobileNo}
                                                                onChange={handleNumberChange}
                                                                placeholder="Mobile Number "

                                                            />
                                                        </div>
                                                    </div>

                                                    {/* whatsapp number */}
                                                    <div className="col-12 col-md-12">
                                                        <label htmlFor="phone" className="form-label">
                                                            Whatsapp Number
                                                        </label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    width={16}
                                                                    height={16}
                                                                    fill="currentColor"
                                                                    className="bi bi-telephone"
                                                                    viewBox="0 0 16 16"
                                                                >
                                                                    <path d="M13.601 2.399A7.94 7.94 0 0 0 8 0a7.94 7.94 0 0 0-5.601 2.399A7.94 7.94 0 0 0 0 8c0 1.299.312 2.564.902 3.694L0 16l4.305-1.158A7.94 7.94 0 0 0 8 16c2.136 0 4.141-.832 5.601-2.399A7.94 7.94 0 0 0 16 8a7.94 7.94 0 0 0-2.399-5.601zm-1.384 10.177c-.298.298-.622.552-.972.765a6.804 6.804 0 0 1-2.938.897h-.001c-1.014 0-2.013-.197-2.94-.583L3.5 14.5l.433-1.581c-.333-.952-.502-1.943-.502-2.946 0-1.94.757-3.764 2.143-5.143A7.14 7.14 0 0 1 8 3c1.94 0 3.764.757 5.143 2.143A7.14 7.14 0 0 1 15.5 8c0 1.94-.757 3.764-2.143 5.143zm-2.434-4.318c-.075-.047-.517-.254-.598-.283-.08-.03-.138-.046-.197.046-.058.093-.226.283-.278.34-.052.058-.102.065-.19.023-.087-.042-.366-.135-1.39-.79-.512-.308-.857-.693-.957-.81-.1-.116-.1-.173-.019-.28.08-.107.108-.18.166-.28.057-.1.027-.17-.015-.237-.042-.066-.389-.93-.532-1.274-.14-.334-.284-.288-.39-.293-.1-.004-.172-.01-.264-.01-.091 0-.238.034-.363.16-.125.126-.478.467-.478 1.145 0 .677.49 1.332.558 1.425.07.093.972 1.485 2.353 2.084.329.142.586.227.787.29.33.105.63.09.87.055.265-.04.82-.333.937-.654.116-.322.116-.598.081-.654-.034-.058-.128-.093-.266-.162z" />
                                                                </svg>

                                                            </span>
                                                            <select
                                                                type="tel"
                                                                className="form-control col-2 mr-1 ml-1"
                                                                name="countryCodewhatsappNo"
                                                                value={NonMemberProfileAdd.countryCodewhatsappNo}

                                                                onChange={handleChange}

                                                            >
                                                                {Country.map((item, i) => (
                                                                    <option key={i} value={item?.phone_code}>
                                                                        {item?.emoji} {item?.phone_code}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="phone"
                                                                name="whatsappNo"
                                                                value={NonMemberProfileAdd.whatsappNo}
                                                                placeholder='Whatsapp Number'
                                                                onChange={handleNumberChange}

                                                            />
                                                        </div>
                                                    </div>
                                                    {/* Website */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Website
                                                        </label>
                                                        <input

                                                            className="form-control"
                                                            type="text"
                                                            name="websiteLink"
                                                            value={NonMemberProfileAdd.websiteLink}
                                                            placeholder="Website Link"
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Address */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Address
                                                        </label>
                                                        <input

                                                            className="form-control"
                                                            type="text"
                                                            name="address"
                                                            value={NonMemberProfileAdd.address}
                                                            placeholder="Address"
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* country  */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Country <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            className="form-control"
                                                            id="fullname"
                                                            name="country"
                                                            value={NonMemberProfileAdd.country}
                                                            onChange={handleChange}

                                                        >
                                                            <option value="" >
                                                                Select Country
                                                            </option>
                                                            {Country.map((item, i) => (
                                                                <option key={i} value={item?._id}>
                                                                    {item?.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* State/emirate  */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Emirate <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            type="text"
                                                            className="form-control"
                                                            id="fullname"
                                                            name="emirate"
                                                            value={NonMemberProfileAdd.emirate}
                                                            onChange={handleChange}

                                                        >
                                                            <option value="" >
                                                                Select Emirate
                                                            </option>
                                                            {CountryWiseState?.map((item, i) => (
                                                                <option key={i} value={item?.name}>
                                                                    {item?.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* Location */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Location Link
                                                        </label>
                                                        <input

                                                            className="form-control"
                                                            type="text"
                                                            name="locationLink"
                                                            value={NonMemberProfileAdd.locationLink}
                                                            placeholder="Location Link"
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    {/* Social */}
                                                    <div className="col-12">
                                                        <label htmlFor="fullname" className="form-label">
                                                            Facebook
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="facebookLink"
                                                            value={NonMemberProfileAdd.facebookLink}
                                                            placeholder="facebook Link"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="linkedInLink" className="form-label">
                                                            LinkedIn
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="linkedInLink"
                                                            value={NonMemberProfileAdd.linkedInLink}
                                                            placeholder="linkedIn Link"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="instaLink" className="form-label">
                                                            Instagram
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="instaLink"
                                                            value={NonMemberProfileAdd.instaLink}
                                                            placeholder="Instagram Link"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="twitterURL" className="form-label">
                                                            neoo Business Page Link
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="neooBusinessPageLink"
                                                            value={NonMemberProfileAdd?.neooBusinessPageLink}
                                                            placeholder="neoo Business Page Links"
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                    <div className="col-12">
                                                        <label htmlFor="youtubeLink" className="form-label">
                                                            YouTube
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="youtubeLink"
                                                            value={NonMemberProfileAdd.youtubeLink}
                                                            placeholder="YouTube Link"
                                                            onChange={handleChange}
                                                        />
                                                    </div>


                                                    <div className="col-12 mt-3">
                                                        <div className="d-flex justify-content-end">
                                                            <button className="btn btn-primary btn-lg" type="submit" onClick={(e) => handleSubmit(e)}>
                                                                Update
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>




            </div>

        </div>
    )
}

export default NonMemberEdit